var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcQuoteLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "15px",
    viewBox: "0 0 21 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icQuoteLeft") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Added-New-Validation-n-Review",
    transform: "translate(-760.000000, -866.000000)",
    fill: "#86D053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    transform: "translate(670.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(72.000000, 668.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(16.505615, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icQuoteLeft",
    transform: "translate(0.000000, 8.390625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7462039,2.28573421 C17.1641579,3.5555929 15.8731543,5.04765448 15.8731543,6.76196372 C16.9736985,6.88894959 17.8837502,7.33868446 18.6033368,8.11118183 C19.3229234,8.8836792 19.6827113,9.77785795 19.6827113,10.7937449 C19.6827113,11.8731248 19.3335054,12.7831765 18.6350831,13.5239274 C17.9366608,14.2646783 17.0583551,14.6350482 16.0001395,14.6350482 C14.8149381,14.6350482 13.7884843,14.1535674 12.9207476,13.1905912 C12.0530108,12.227615 11.6191489,11.0583043 11.6191489,9.6826241 C11.6191489,5.55558336 13.9260243,2.32807427 18.5398442,0 L19.7462039,2.28573421 Z M8.12705498,2.28573421 C5.52384467,3.5555929 4.22225903,5.04765448 4.22225903,6.76196372 C5.34396754,6.88894959 6.26460128,7.33868446 6.98418788,8.11118183 C7.70377447,8.8836792 8.06356237,9.77785795 8.06356237,10.7937449 C8.06356237,11.8731248 7.70906547,12.7831765 7.00006103,13.5239274 C6.2910566,14.2646783 5.40745984,14.6350482 4.34924427,14.6350482 C3.16404282,14.6350482 2.14288011,14.1535674 1.2857255,13.1905912 C0.428570879,12.227615 0,11.0583043 0,9.6826241 C0,5.55558336 2.29629335,2.32807427 6.88894895,0 L8.12705498,2.28573421 Z",
    id: "\\u201C"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuoteLeft);
export default __webpack_public_path__ + "static/media/icQuoteLeft.2c59109f640d0d19283f5e1c1a6c42e9.svg";
export { ForwardRef as ReactComponent };